export const environment = {
  name: "DC",
  production: true,
  endpointFeatureFlags: {
    url: "https://dc-lex-backoffice-api.hub.conexia.com.br",
    routes: {
      get_feature_flags: "/api/v1/featureflags",
    },
  },
  endpointAnalytics: {
    url: "https://dc-api.hub.conexia.com.br",
    routes: {
      get_dashboard: "/analytics/v1/dashboard/iud",
    },
  },
  endpointDashboard: {
    url: "https://dc-backoffice-api.hub.conexia.com.br",
    routes: {
      get_segments: "/api/v1/Dashboard/GetSegments",
      get_users: "/api/v1/Dashboard/GetUsers",
      get_users_per_application: "/api/v1/Dashboard/GetUsersPerApplications",
      get_digital_usages: "/api/v1/Dashboard/GetDigitalUsages",
      get_cached_users_per_aplications:
        "/api/v1/Dashboard/GetCachedUsersPerApplications",
      get_cached_segments_and_profiles:
        "/api/v1/Dashboard/GetCachedSegmentsAndProfiles",
      get_cached_digital_usages: "/api/v1/Dashboard/GetCachedDigitalUsages",
    },
  },
  endpointSchool: {
    url: "https://dc-backoffice-api.hub.conexia.com.br",
    routes: {
      post_school: "/api/v1/school",
      put_school: "/api/v1/school/edit",
      post_school_multiple: "/api/v1/school/multiple",
      get_school: "/api/v1/school/paginate",
      get_school_id: "/api/v1/school?schoolId={schoolId}",
      get_school_schoolOptions: "/api/v1/school/schooloptions",
      get_school_count: "/api/v1/school/schoolCount",
      get_school_schoolOptions_tenantId:
        "/api/v1/school/schooloptions/{tenantId}",
      get_tenant_options: "/api/v1/tenant/tenantoptions",
      post_teanant: "/api/v1/tenant",
      get_tenant_id: "/api/v1/tenant/{tenantId}",
      get_current_tenant: "/api/v1/tenant/GetCurrentTenant",
      get_tenant: "/api/v1/tenant",
      put_tenant_id: "/api/v1/tenant/{tenantId}",
      get_license_order_number_existing:
        "/api/v1/Tenant/{tenantId}/licenses/orders/validate/number/{number}",
    },
  },
  endpointUpdatedSchool: {
    url: "https://dc-lex-backoffice-api.hub.conexia.com.br",
    routes: {
      get_school_id: "/api/v1/school/{schoolId}",
      post_school: "/api/v1/school",
      put_school: "/api/v1/school/{schoolId}",
      get_school_class: "/api/v1/school/{schoolId}/classes",
      get_subjects: "/api/v1/school/{schoolId}/grades/{gradeId}/subjects",
      get_school_types: "/api/v1/school/school-types",
    },
  },
  endpointOccurrenceBackoffice: {
    url: "https://dc-lex-backoffice-api.hub.conexia.com.br",
    routes: {
      get_status: "/api/v1/occurrence/status",
    },
  },
  endpointSchoolClass: {
    url: "https://dc-backoffice-api.hub.conexia.com.br",
    routes: {
      post_group: "/api/v1/group",
      post_group_import: "/api/v1/usergroup/import",
      get_group: "/api/v1/group",
      get_group_id: "/api/v1/group/{groupId}",
      get_group_paginate: "/api/v1/group/paginate",
      get_group_autoComplete: "/api/v1/group/autocomplete",
      put_group_id: "/api/v1/group/{groupId}",
      get_group_school_id: "/api/v1/group/getbyschoolid/{schoolid}",
      post_group_groupUpdateInBatch: "/api/v1/group/GroupUpdateInBatch",
      get_export: "/api/v1/usergroup/export/{schoolId}",
      post_credentials_group: "/api/v1/Group/GenerateCredentials",
      put_change_status_in_batch: "/api/v1/Group/changeStatusInBatch",
      post_credentials_for_profiles:
        "/api/v1/Group/GenerateCredentialsForProfiles",
    },
  },
  endpointTag: {
    url: "https://dc-backoffice-api.hub.conexia.com.br",
    routes: {
      post_tag: "/api/v1/tag",
      get_tag: "/api/v1/tag",
      get_tag_paginate_administrator_url: "/api/v1/tag/administrator/paginate",
      get_tag_id: "/api/v1/tag/{tagId}",
      get_tag_schoolId: "/api/v1/tag/school/{schoolId}",
      get_tagType: "/api/v1/tagtype",
      put_tag_id: "/api/v1/tag/{tagId}",
    },
  },
  endpointTagV2: {
    url: "https://dc-lex-backoffice-api.hub.conexia.com.br",
    routes: {
      get_structured_tag: "/api/v2/tags",
      get_tags_options: "/api/v2/tags/get-child/{parentId}",
    },
  },
  endpointAccount: {
    url: "https://dc-backoffice-api.hub.conexia.com.br",
    routes: {
      post_account: "/api/v1/user",
      put_account: "/api/v1/user",
      get_account_id: "/api/v1/user/{accountId}",
      get_account_paginate: "/api/v1/user/paginate",
      get_account_autocomplete: "/api/v1/user/autocomplete",
      get_account_informations_id: "/api/v1/user/informations/{accountId}",
      get_profile: "/api/v1/profile",
      get_profile_all: "/api/v1/profile/getall",
      get_profile_paginate: "/api/v1/profile/paginate",
      get_profile_autocomplete: "/api/v1/profile/autocomplete",
      get_profile_currentRole: "/api/v1/profile/currentrole",
      get_profile_currentUser: "/api/v1/profile/currentuser",
      get_profile_currentTenantId: "/api/v1/profile/currenttenantid",
      post_resend_access_email:
        "/api/v1/user/{userId}/resendAccessEmail/{forceSendEmail}",
      post_resend_batch_access_email: "/api/v1/user/resendBatchAccessEmail",
    },
  },
  endpointUser: {
    url: "https://dc-lex-backoffice-api.hub.conexia.com.br",
    routes: {
      post_account: "/api/v1/user",
      put_account: "/api/v1/user/{accountId}",
      get_account_informations_id: "/api/v1/user/{accountId}",
      get_user_info: "/api/v1/user/userinfo",
      get_user_suggestions: "/api/v1/user/suggestions",
      get_account_paginate: "/api/v2/user/paginate",
      post_invitation_lex_account: "/api/v1/user/invites",
      get_history_paginate: "/api/v1/Enrollment/GetPaginate",
      post_user_export_onboarding: "/api/v1/User/export-onboarding",
      post_export_document_onboarding:
        "/api/v1/user/export-document-onboarding",
      get_historic_user: "/api/v1/Enrollment/historic-details/{historyId}",
      get_historic_user_by_id:
        "/api/v1/Enrollment/historic-userId/{userId}/courseId/{courseId}",
      get_account_verification_link:
        "/api/v1/user/generate-link-onboarding/{userId}",
      post_send_pendings: "/api/v1/Pending/SendPendings",
      put_unlink_academic_email:
        "/api/v1/pending/academic-email-google/reset/{userId}",
      put_integration_economic_group:
        "/api/v1/pending/tenant/googleintegration",
      post_email_recovery_password: "/api/v1/user/email-reset-password",
      put_change_login: "/api/v1/user/change-username/",
      get_user_iso: "/api/v1/tenants/country-iso-code",
      put_change_email: "/api/v1/user/change-email",
      get_documents: "/api/v1/user/documents",
      get_user_find: "/api/v1/user/user-find",
      post_family: "/api/v1/family",
      put_family: "/api/v1/family",
      get_family: "/api/v1/family",
      get_merge_candidates: "/api/v1/user/merge/candidates",
      post_merge_preview: "/api/v1/user/merge/preview",
      post_merge: "/api/v1/user/merge",
    },
  },
  endpointOccurrency: {
    url: "https://dc-backoffice-api.hub.conexia.com.br",
    routes: {
      get_occurrency_id: "/api/v1/occurrency/{occurrencyId}",
      get_occurrency_paginate: "/api/v1/occurrency/paginate",
      put_occurrency: "/api/v1/occurrency/{action}/{occurrencyId}",
      download_occurrency_id: "/api/v1/occurrency/download/{occurrencyId}",
      get_occurrency_operation: "/api/v1/Occurrency/OcurrencyOperation",
      get_grouped_details: "/api/v1/Occurrency/{occurrenceId}/groupedDetails",
      get_details_paginate:
        "/api/v1/Occurrency/{occurrenceId}/details/paginate",
    },
  },
  endpointProduct: {
    url: "https://dc-backoffice-api.hub.conexia.com.br",
    routes: {
      //Brand
      post_brand: "/api/v1/brand",
      get_brand: "/api/v1/brand",
      get_brand_id: "/api/v1/brand/{brandId}",
      get_brand_getAll: "/api/v1/brand/getall",
      put_brand: "/api/v1/brand/{brandId}",
      //Combo
      get_combo_getAll: "/api/v1/combo/getall",
      get_combo_paginate: "/api/v1/combo/paginate",
      get_combo_brand_id: "/api/v1/combo/brand/{brandId}",
      get_combo_id: "/api/v1/combo/{comboId}",
      put_combo_id: "/api/v1/combo/{comboId}",
      post_combo: "/api/v1/combo",
      delete_combo: "/api/v1/combo/{comboId}",
      //Licence
      post_licence: "/api/v1/licence",
      put_licence: "/api/v1/licence/{licenceId}",
      get_licence_id: "/api/v1/licence/{licenceId}",
      get_licence_matchGroups: "/api/v1/licence/matchgroups",
      get_licence_paginate: "/api/v1/licence/paginate",
      put_licence_id: "/api/v1/licence/{licenceId}",
      get_licenses_of_class: "/api/v1/licence/granted_to_class",
      //product
      get_product_filter: "/api/v1/product/filter",
      get_product_id: "/api/v1/product/{productId}",
      put_product_id: "/api/v1/product/{productId}",
      get_product_getall: "/api/v1/product/getall",
      post_product: "/api/v1/product",
    },
  },
  //permission
  endpointPermission: {
    url: "https://dc-backoffice-api.hub.conexia.com.br",
    routes: {
      post_permission: "/api/v1/permission",
      put_permission: "/api/v1/permission/{permissionId}",
      get_permission_paginate: "/api/v1/permission/paginate",
      get_all_permission_paginate: "/api/v1/permission",
      get_permission_id: "/api/v1/permission/{permissionId}",
    },
  },
  endpointSegment: {
    url: "https://dc-backoffice-api.hub.conexia.com.br",
    routes: {
      post_segment: "/api/v1/segment",
      get_segment: "/api/v1/segment",
      get_segment_grade: "/api/v1/segment/grade",
      get_segment_id: "/api/v1/segment/{segmentId}/school/{schoolId}",
      put_segment: "/api/v1/segment/{segmentId}",
    },
  },
  endpointGrade: {
    url: "https://dc-backoffice-api.hub.conexia.com.br",
    routes: {
      post_grade: "/api/v1/grade",
      get_grade: "/api/v1/grade",
      get_grade_id: "/api/v1/grade/{gradeId}",
      get_grade_segment_id: "/api/v1/grade/segment/",
      get_grouped_grade_url: "/api/v1/grade/grouped",
      put_grade: "/api/v1/grade/{gradeId}",
    },
  },
  endpointClass: {
    url: "https://dc-backoffice-api.hub.conexia.com.br",
    routes: {
      get_many: "/api/v1/class/getMany",
      post_class: "/api/v1/class",
      get_class_paginate_grade: "/api/v1/class/paginate",
      get_turn_paginate: "/api/v1/class/turn",
      get_all_turns: "/api/v1/class/turn/getall",
      get_class_id: "/api/v1/class/{classId}",
      put_class: "/api/v1/class/{classId}",
      post_course_on_class: "/api/v1/class/onclass",
      get_initialSetup: "/api/v1/InitialSetup/StudentAccessType",
      post_initialSetup: "/api/v1/InitialSetup",
      get_resume_initialSetup: "/api/v1/InitialSetup/{schoolId}",
      get_AllowInitialSetup_url: "/api/v1/InitialSetup/schoolId/{schoolId}",
      get_groups_by_classes_segment:
        "/api/v1/class/course/{courseId}/segment/{segmentId}",
    },
  },
  endpointCourse: {
    url: "https://dc-lex-backoffice-api.hub.conexia.com.br",
    routes: {
      get_course_paginate: "/api/v1/Course/GetPaginate",
      get_course_id: "/api/v1/Course/{courseId}",
      put_course: "/api/v1/Course/{courseId}",
      post_course: "/api/v1/Course",
      get_course_options: "/api/v1/Course/basiclist",
      get_course_options_by_school_id_and_year:
        "/api/v1/Course/by-school/?schoolid={schoolId}&schoolyear={ano}",
      get_informations_for_class_url:
        "/api/v1/Course/informationsforclass/{courseId}",
      get_course_turnover_options: "/api/v1/Course/turnover-options",
      get_licenses_of_course: "/api/v2/License/GetByGradeSchool",
      post_group_import: "/api/v1/Enrollment/import-course",
      get_user_course: "/api/v1/Course/get-students-course",
      get_historic_user: "/api/v1/Enrollment/historic-details/{historyId}",
      post_student_on_course: "/api/v1/Enrollment/Course/{courseId}",
      post_join_students: "/api/v1/Course/classes/{classId}",
      post_finish_enrollment: "/api/v1/Enrollment/Course/{courseId}/Completion",
      post_student_in_course_by_classes:
        "/api/v1/enrollment/classes/{studentId}",
      get_products_license: "/api/v1/Course/course-license-information",
      get_class_of_course: "/api/v1/Course/classes",
      get_export_user_course: "/api/v1/course/lexexport",
    },
  },
  endpointUserHelp: {
    url: "https://dc-backoffice-api.hub.conexia.com.br",
    routes: {
      getUserHelp: "/api/v1/userhelp/gethelp",
    },
  },
  endpointSSO: {
    url: "https://dc-sso.hub.conexia.com.br",
    routes: {},
  },
  endpointImpersonate: {
    url: "https://dc-lex-backoffice-api.hub.conexia.com.br",
    routes: {
      impersonate: "/api/v1/Impersonate/{userId}",
      changePassword: "/api/v1/impersonate/change-password/",
    },
  },
  endpointFieldRestriction: {
    url: "https://dc-lex-backoffice-api.hub.conexia.com.br",
    routes: {
      field_restriction: "/api/v1/field-restriction/{userId}",
      migrated_field_restriction:
        "/api/v1/field-restriction/hasmigrated/{userId}",
    },
  },
  endpointTenantBrand: {
    url: "https://dc-lex-backoffice-api.hub.conexia.com.br",
    routes: {
      getBrands: "/api/v2/TenantBrand",
    },
  },
  endpointPreEnrollment: {
    url: "https://dc-lex-backoffice-api.hub.conexia.com.br",
    routes: {
      put_aprove_pre_enrollment: "/api/v1/Occurrence/{action}/{occurrenceId}",
    },
  },
  endpointHelpDesk: {
    url: "https://dc-lex-backoffice-api.hub.conexia.com.br",
    routes: {
      get_help_desk_script: "/api/v1/helpdesk",
    },
  },
  endPointPendings: {
    url: "https://dc-lex-backoffice-api.hub.conexia.com.br",
    routes: {
      post_pendings_clean: "/api/v1/pending/integration/google/clean",
      post_registration_pending_url:
        "/api/v1/user/pendings/{tenantId}/{pendingType}",
    },
  },
  endpointLexUiWeb: {
    url: "https://dc-sso.lex.education",
    routes: {
      logout: "/logout",
    },
  },
  endpointSubjects: {
    url: "https://dc-lex-backoffice-api.hub.conexia.com.br",
    routes: {
      post_subjects_get_sets: "/api/v1/subjects/sets",
    },
  },
  endPointGoogleIntegration: {
    url: "https://dc-api.lex.education/integration",
    routes: {
      association: "/v1/googleintegrator/association",
      get_paginate: "/v1/integrations/tenant/get-paginate",
      service_configuration_id:
        "/v1/googleintegrator/tenant/{serviceConfigurationId}",
      get_integrations: "/v1/googleintegrator/integrations/{integrationId}",
      get_integrations_paginate: "/v1/googleintegrator/paginated",
      get_validation_integration: "/v1/googleintegrator/validation-google",
      put_configuration_integration: "/v1/googleintegrator/configuration",
      delete_integration: "/v1/googleintegrator/configurations/{referenceId}",
    },
  },
  endpointIntegration: {
    url: "https://dc-lex-integration-api.hub.conexia.com.br",
    routes: {
      get_integration_paginate: "/api/v1/integrations/paginated",
      get_lti_integration_parameters: "/api/v1/lti/1p0/parameters",
      get_lti_integration_by_id: "/api/v1/lti/1p0/configurations/{id}",
      post_lti_integration: "/api/v1/lti/1p0/configurations",
      put_lti_integration: "/api/v1/lti/1p0/configurations",
      get_lti_roles: "/api/v1/lti/1p0/roles",
      get_token_embeed: "/api/v1/reports/token-embed",
    },
  },
  endpointContent: {
    url: "https://dc-api.lex.education/integration",
    routes: {
      get_content_paginate: "/v1/lti/content",
      get_content_by_id: "/v1/lti/content/{id}",
      post_content: "/v1/lti/content",
      put_content: "/v1/lti/content/{id}",
    },
  },
  endpointBackofficeGateway: {
    url: "https://dc-api.lex.education/backoffice",
    routes: {
      get_all_schools: "/v1/school/list-schools",
      get_all_tenants: "/v1/tenants/names",
      export_class_pdf: "/v1/classes/class-id-card-info",
      post_export_pdf: "/v1/user/id-card-info/",
    },
  },
  endpointClassesForm: {
    url: "https://dc-api.lex.conexia.com.br/backoffice",
    routes: {
      get_classes: "/v1/classes/school/{schoolId}",
      get_courses: "/v1/course/school/{schoolId}",
    },
  },
  endpointBackoffice: {
    url: "https://dc-lex-backoffice-api.hub.conexia.com.br/api",
    routes: {
      export_pdf: "/v1/classes/export-pdf",
      get_profiles_by_class: "/v1/Classes/{classId}/profiles",
    },
  },
  endpointIntegrationsGateway: {
    url: "https://dc-api.lex.education/integration",
    routes: {
      delete_integration: "/v1/integrations/{id}",
    },
  },
  endpointI18NGateway: {
    url: "https://dc-api.lex.education/i18n",
    routes: {
      get_all_languages: "/v1/languages",
      get_all_countries: "/v1/countries",
    },
  },
  endpointSubjectGateway: {
    url: "https://dc-api.lex.education/backoffice",
    routes: {
      post_subject: "/v1/subject",
      put_subject: "/v1/subject/{subjectId}",
      delete_subject: "/v1/subject/{subjectId}",
      get_subject_paginate: "/v1/subject/get-paginate",
      get_subjects_options: "/v1/subject/get-all",
    },
  },
  endpointSetGateway: {
    url: "https://dc-api.lex.education/backoffice",
    routes: {
      get_set_paginate: "/v1/set/get-paginate",
      delete_subject_set: "/v1/set/{setId}",
      post_subject_set: "/v1/set",
      get_subject_set_id: "/v1/set/{setId}",
      put_subject_set: "/v1/set/{setId}",
      get_set_schools_paginate: "/v1/set/schools-get-paginate",
      get_school_options: "/v1/set/{setId}/tenants",
    },
  },
  endpointLexProduct: {
    url: "https://dc-lex-backoffice-api.hub.conexia.com.br",
    routes: {
      get_licenses_type: "/api/v2/License/release-type-license/all",
    },
  },
  endpointSchoolProducts: {
    url: "https://dc-lex-backoffice-api.hub.conexia.com.br",
    routes: {
      get_product_paginate: "/api/v1/Product/paginate",
    },
  },
  endpointI18nCDN: {
    url: "https://dev-i18n.lex.education",
  },
  endpointLexSso: {
    url: "https://dc-api.lex.education",
    routes: {
      impersonate: "/sso/v1/legacytokens/impersonate/",
    },
  },
  endpointOnboarding: {
    url: "https://dc-queuing-hangfire.hub.conexia.com.br/",
    routes: {
      get_config: "api/v1/onboarding/config/{tenantId}",
      post_config: "api/v1/onboarding/config",
      put_config: "api/v1/onboarding/config",
      post_execute: "api/v1/onboarding/execute",
    },
  },
  sprinklrUris: {
    SPRINKLR_API_KEY: "67a12628-15c7-40e8-886d-ac348d155ea3",
    SPRINKLR_APP_ID: "66042a946f8e4666e8c43b2c_app_100717800",
    SPRINKLR_APP_CONTEXT_KEY: "_c_650ca62b974b905e0e801637",
    MAPLE_GLOBAL_ID: "54517b8e-3444-435c-bb71-4893468e3dac",
  },
  chatVoltUris: {
    agentId: 'cmkod7amy00zo9feez53yhbok'
  },
  P_ID_PRIVALLY: "18a0ae-f84bb4",
  powerBiEnvs: {
    EMBEED_URL: "https://app.powerbi.com/reportEmbed?reportId={reportId}",
    workspace_id: "e1e9eb71-aa5a-46d6-a931-9a146980c1b7",
    report_id: "3b311843-41c7-4d4b-aaf6-3af428a002af",
  },
  observability: {
    enabled: true,
    serviceName: "lex-hub-front-end",
    serviceNamespace: "lex",
    serviceVersion: "1.0.0",
    deploymentEnvironment: "dc",
    exporterEndpoint: "https://otel-gateway.devops.lex.education",
    tracesExporter: "otlp" as const,
    logsExporter: "otlp" as const,
    metricsExporter: "otlp" as const,
    propagationOrigins: [],
  },
  endpointClasses: {
    url: "https://dc-lex-backoffice-api.hub.conexia.com.br",
    routes: {
      post_update_in_batch:
        "/api/v1/classes/update-in-batch",
    },
  },
}
